import useAppealPayment from '@/apis/payments/hooks/useAppealPayment'
import { PAYMENT_TYPES } from '@/apis/providers/types/provider.types'
import CreateProviderPaymentForm, {
  ProviderPaymentDetails,
} from '@/app/pages/providers/create_provider_request_form'
import { ProviderPaymentStep } from '@/app/pages/providers/provider.constants'
import { PaymentDetail } from '@/schemas/payments.schema'
import { useState } from 'react'
import PaymentAppealSuccess from '../payment_appeal_success'
import ExplainAppealPage from './_components/explain_appeal'

type Props = {
  payment: PaymentDetail
}

export function ProviderAppealLayout(props: Props) {
  const { payment } = props
  const [appealReason, setAppealReason] = useState<string>('')
  const [appealStep, setAppealStep] = useState<'explain-appeal' | 'flow'>(
    'explain-appeal'
  )

  const appealMutation = useAppealPayment()

  const defaultValues: ProviderPaymentDetails = {
    amount: payment.amount_provider,
    baseAmount: payment.amount_provider,
    comments: payment.comments ?? '',
    documents: payment.payment_documents.map((doc) => doc.path),
    expenseCategories: payment.expense_categories.map((category) => ({
      id: category.id,
      amount: category.amount,
      name: category.name,
    })),

    invoiceNumber: payment.invoice_quote ?? '',
    provider: {
      id: payment.provider_id!,
      name: payment.provider_name!,
      email: '',
      location: '',
    },
    purses: payment.purse_movements.map((purse) => ({
      purse_id: purse.purse_id,
      amount: purse.amount,
      hasBeenManuallyEdited: false,
      isSelected: true,
      name: purse.name,
    })),
  }

  const FORCE_UPDATE_APPEAL_TO_IN_APPEAL_STATUS = 3

  function handleAppealSubmit(data: ProviderPaymentDetails) {
    appealMutation.mutate({
      applicant_appeal_message: appealReason,
      files: [],
      global_expense_categories: data.expenseCategories.map((category) => ({
        id: category.id,
        amount: category.amount,
      })),
      invoice_quote: data.invoiceNumber,
      comments: data.comments,
      payment_id: payment.payment_id,
      program_id: payment.program_id,
      base_amount: data.baseAmount,
      provider_id: data.provider.id,
      type: PAYMENT_TYPES.PROVIDER,
      purses: data.purses.map((purse) => ({
        purse_id: purse.purse_id,
        amount: purse.amount,
      })),
      status: FORCE_UPDATE_APPEAL_TO_IN_APPEAL_STATUS,
      total_amount: data.amount,
    })
  }

  if (appealStep === 'explain-appeal') {
    return (
      <ExplainAppealPage
        onSubmit={(appealReason) => {
          setAppealReason(appealReason.reasonForAppeal)
          setAppealStep('flow')
        }}
      />
    )
  }

  if (appealMutation.status === 'success') {
    return <PaymentAppealSuccess />
  }

  return (
    <div>
      <CreateProviderPaymentForm
        onExitFormBackClick={() => {
          setAppealStep('explain-appeal')
        }}
        defaultStep={ProviderPaymentStep.ADD_DETAILS}
        onSubmit={(data) => {
          handleAppealSubmit(data)
        }}
        mutationStatus={appealMutation.status}
        defaultValues={defaultValues}
      />
    </div>
  )
}
